import { Component, ChangeDetectionStrategy } from '@angular/core';
import { LanguageService } from '../../i18n/language.service';


@Component({
  selector: 'app-page4day',
  standalone: false,
  templateUrl: './page4day.component.html',
  styleUrls: ['./page4day.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush

})
export class Page4dayComponent {
  constructor(public language: LanguageService) {}
}
